export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./categories.vue?vue&type=template&id=0410f05a"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/basement/categories.vue?vue&type=template&id=0410f05a
// module id = 0uJO
// module chunks = 0